export default __webpack_public_path__ + "static/media/option_bg.7717b6bf.png";